import envValues from "../enviornment";

export const SERVER_URL = `${envValues.REACT_APP_API_ENDPOINT}/auth`;
export const SERVER_BASE_URL = envValues.REACT_APP_API_ENDPOINT;
export const ERROR_MESSAGE = "Api Fetch Error!";
export const ENCRYPT_SECERET_KEY = "armia-secret-key@123";
export const REACT_APP_API_POST_USER = `${envValues.REACT_APP_API_ENDPOINT}/user`;
export const REACT_APP_API_FETCH_USER = `${envValues.REACT_APP_API_ENDPOINT}/user?`;
export const REACT_APP_API_FETCH_ADMIN_USER = `${envValues.REACT_APP_API_ENDPOINT}/adminuser?`;
export const REACT_APP_API_FETCH_APP_USERS = `${envValues.REACT_APP_API_ENDPOINT}/user/normal-users?`;
export const REACT_APP_API_USER_EXPORT = `${envValues.REACT_APP_API_ENDPOINT}/user/export`;
export const REACT_APP_API_VENDOR_EXPORT = `${envValues.REACT_APP_API_ENDPOINT}/vendor/export`;
export const REACT_APP_API_FETCH_FINANCE_DATA = `${envValues.REACT_APP_API_ENDPOINT}/dashboard/finance-data?`;

export const REACT_APP_API_FETCH_EMPLOYEE = `${envValues.REACT_APP_API_ENDPOINT}/employee?active=true&`;
export const REACT_APP_API_FETCH_ROLE = `${envValues.REACT_APP_API_ENDPOINT}/roles?active=true&`;
export const REACT_APP_API_SKILLS = `${envValues.REACT_APP_API_ENDPOINT}/dummy/selectdata`;
export const REACT_APP_API_ROLES_DROPDOWN = `${envValues.REACT_APP_API_ENDPOINT}/roles/select`;
export const REACT_APP_API_CAFES_DROPDOWN = `${envValues.REACT_APP_API_ENDPOINT}/cafe/select`;
export const REACT_APP_API_CAFE_PICKER = `${envValues.REACT_APP_API_ENDPOINT}/cafe/picker`;

export const REACT_APP_API_FETCH_MOVIES = `${envValues.REACT_APP_API_ENDPOINT}/movies?active=true&`;
export const REACT_APP_API_FETCH_NOTIFICATIONS = `${envValues.REACT_APP_API_ENDPOINT}/notifications?`;

export const REACT_APP_API_FETCH_ORDERS = `${envValues.REACT_APP_API_ENDPOINT}/orders?`;
export const REACT_APP_API_ORDERS_EXPORT = `${envValues.REACT_APP_API_ENDPOINT}/orders/export`;

export const REACT_APP_API_FETCH_VENDOR = `${envValues.REACT_APP_API_ENDPOINT}/vendor?`;
export const REACT_APP_API_FETCH_CAFE = `${envValues.REACT_APP_API_ENDPOINT}/cafe?`;
export const REACT_APP_API_FETCH_CONTACT_US = `${envValues.REACT_APP_API_ENDPOINT}/enquiries?`;

export const REACT_APP_API_VENDORS_LIST = `${envValues.REACT_APP_API_ENDPOINT}/vendor/vendor-list?`;
export const REACT_APP_API_FETCH_ZIPCODES = `${envValues.REACT_APP_API_ENDPOINT}/cafe/zip-codes?`;
export const REACT_APP_API_FETCH_FEEDBACK = `${envValues.REACT_APP_API_ENDPOINT}/feedback?`;
export const REACT_APP_API_FEEDBACK_RESOLVE = `${envValues.REACT_APP_API_ENDPOINT}/feedback`;
export const REACT_APP_API_ISSUE_RESOLVE = `${envValues.REACT_APP_API_ENDPOINT}/issues`;
export const REACT_APP_API_TICKET_RESOLVE = `${envValues.REACT_APP_API_ENDPOINT}/tickets`;
export const REACT_APP_API_FETCH_ISSUES = `${envValues.REACT_APP_API_ENDPOINT}/issues?`;
export const REACT_APP_API_FETCH_TICKETS = `${envValues.REACT_APP_API_ENDPOINT}/tickets?`;

export const REACT_APP_API_FETCH_UNAPPROVED_BANKS = `${envValues.REACT_APP_API_ENDPOINT}/payoutaccounts/unapproved-banks?`;
export const REACT_APP_API_FETCH_PAYOUT_REQUESTS = `${envValues.REACT_APP_API_ENDPOINT}/payouts/payout-requests?`;
export const REACT_APP_API_FETCH_DRINKTYPES = `${envValues.REACT_APP_API_ENDPOINT}/drinktypes?`;
export const REACT_APP_API_FETCH_DRINKTYPES_WITHOUT_PAGINATION = `${envValues.REACT_APP_API_ENDPOINT}/drinktypes/without-pagination?`;
export const REACT_APP_API_DRINKTYPE_ORDER_UPDATE = `${envValues.REACT_APP_API_ENDPOINT}/drinktypes/order-rearrangement`;

export const REACT_APP_API_FETCH_CATEGORIES = `${envValues.REACT_APP_API_ENDPOINT}/category?`;
export const REACT_APP_API_FETCH_CATEGORIES_WITHOUT_PAGINATION = `${envValues.REACT_APP_API_ENDPOINT}/category/without-pagination?`;

export const REACT_APP_API_CATEGORY_DROPDOWN = `${envValues.REACT_APP_API_ENDPOINT}/category/dropdown`;
export const REACT_APP_API_CATEGORY_ORDER_UPDATE = `${envValues.REACT_APP_API_ENDPOINT}/category/order-rearrangement`;

export const REACT_APP_API_ATTRIBUTES = `${envValues.REACT_APP_API_ENDPOINT}/attributes`;

export const REACT_APP_API_FETCH_MENUS = `${envValues.REACT_APP_API_ENDPOINT}/menus`;
export const REACT_APP_API_FETCH_CLAIM_REQUESTS = `${envValues.REACT_APP_API_ENDPOINT}/cafe/claim-requests`;
export const REACT_APP_API_FETCH_PARTICIPATION_REQUESTS = `${envValues.REACT_APP_API_ENDPOINT}/cafe/participation-requests?`;
export const REACT_APP_API_FETCH_PARTICIPATION_REQUESTS_DETAILS = `${envValues.REACT_APP_API_ENDPOINT}/cafe/participation-requests-details`;
export const REACT_APP_API_FETCH_SUGGESTED_CAFES = `${envValues.REACT_APP_API_ENDPOINT}/cafe/suggested-cafes?`;
export const REACT_APP_API_FETCH_SUGGESTED_EDITS = `${envValues.REACT_APP_API_ENDPOINT}/cafe/suggested-edits?`;
export const REACT_APP_API_UPDATE_SUGGESTION_STATUS = `${envValues.REACT_APP_API_ENDPOINT}/cafe/suggested-cafe`;


export const REACT_APP_API_APPROVE_CLAIM_REQUESTS = `${envValues.REACT_APP_API_ENDPOINT}/cafe/approve-cafe`;
export const REACT_APP_API_REJECT_CLAIM_REQUESTS = `${envValues.REACT_APP_API_ENDPOINT}/cafe/reject-cafe`;
export const REACT_APP_API_FETCH_CLAIM_REQUESTS_OUTSIDE = `${envValues.REACT_APP_API_ENDPOINT}/cafe/cafe-claim-requests?`;
export const REACT_APP_API_DRINKTYPES = `${envValues.REACT_APP_API_ENDPOINT}/drinktypes/list-drinktypes?`;
export const REACT_APP_API_ADDONS = `${envValues.REACT_APP_API_ENDPOINT}/addons`;
export const REACT_APP_API_COUPONS = `${envValues.REACT_APP_API_ENDPOINT}/coupons?`;

// 2FA OTP Endpoints
export const REACT_APP_API_SEND_OTP = `${envValues.REACT_APP_API_ENDPOINT}/auth/send-otp`;
export const REACT_APP_API_VERIFY_OTP = `${envValues.REACT_APP_API_ENDPOINT}/auth/verify-otp`;
export const REACT_APP_API_RESEND_OTP = `${envValues.REACT_APP_API_ENDPOINT}/auth/resend-otp`;

// Cafe Merge Endpoints
export const REACT_APP_API_FETCH_MERGE_REQUESTS = `${envValues.REACT_APP_API_ENDPOINT}/cafe/merge-requests?`;
export const REACT_APP_API_MERGE_REQUEST_DETAIL = `${envValues.REACT_APP_API_ENDPOINT}/cafe/merge-requests`;
export const REACT_APP_API_SIMILAR_CAFES = `${envValues.REACT_APP_API_ENDPOINT}/cafe/similar`;
export const REACT_APP_API_MERGE_SUGGESTION = `${envValues.REACT_APP_API_ENDPOINT}/cafe/merge-suggestion`;
export const REACT_APP_API_MERGE_APPROVE = `${envValues.REACT_APP_API_ENDPOINT}/cafe/merge-requests/approve`;
export const REACT_APP_API_MERGE_REJECT = `${envValues.REACT_APP_API_ENDPOINT}/cafe/merge-requests/reject`;
export const REACT_APP_API_DIRECT_MERGE = `${envValues.REACT_APP_API_ENDPOINT}/cafe/merge`;

// Cafe Import Endpoints
export const REACT_APP_API_CAFE_IMPORT_VALIDATE = `${envValues.REACT_APP_API_ENDPOINT}/cafe/import/validate`;
export const REACT_APP_API_CAFE_IMPORT = `${envValues.REACT_APP_API_ENDPOINT}/cafe/import`;

// Cafe Export Endpoints
export const REACT_APP_API_CAFE_EXPORT = `${envValues.REACT_APP_API_ENDPOINT}/cafe/export`;
export const REACT_APP_API_CAFE_TRANSACTION_REPORT = (cafeId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/cafe/${cafeId}/transaction-report`;

// POS Endpoints
export const REACT_APP_API_REFRESH_POS_ITEMS = `${envValues.REACT_APP_API_ENDPOINT}/pos/refresh-items`;

// Vendor Onboarding/Application Endpoints
export const REACT_APP_API_FETCH_VENDOR_APPLICATIONS = `${envValues.REACT_APP_API_ENDPOINT}/cafe/vendor-applications?applicationStatus=Submitted&applicationStatus=In Review&`;
export const REACT_APP_API_FETCH_ORDER_AHEAD_REQUESTS = `${envValues.REACT_APP_API_ENDPOINT}/cafe/order-ahead-requests?orderAheadStatus=submitted&orderAheadStatus=in_review&`;
export const REACT_APP_API_ORDER_AHEAD_REQUEST_DETAILS = `${envValues.REACT_APP_API_ENDPOINT}/cafe/order-ahead-requests`;
export const REACT_APP_API_VENDOR_APPLICATION_DETAILS = `${envValues.REACT_APP_API_ENDPOINT}/cafe/vendor-applications`;
export const REACT_APP_API_APPROVE_APPLICATION = `${envValues.REACT_APP_API_ENDPOINT}/cafe/approve-cafe`;
export const REACT_APP_API_REJECT_APPLICATION = `${envValues.REACT_APP_API_ENDPOINT}/cafe/reject-cafe`;
export const REACT_APP_API_UPLOAD_AGREEMENT = `${envValues.REACT_APP_API_ENDPOINT}/settings/upload-agreement`;
export const REACT_APP_API_GET_CURRENT_AGREEMENT = `${envValues.REACT_APP_API_ENDPOINT}/settings/current-agreement`;
export const REACT_APP_API_OVERRIDE_STRIPE = `${envValues.REACT_APP_API_ENDPOINT}/cafe`;
export const REACT_APP_API_REVIEW_DOCUMENT = `${envValues.REACT_APP_API_ENDPOINT}/cafe`;

// App Versions
export const REACT_APP_API_FETCH_APP_VERSIONS = `${envValues.REACT_APP_API_ENDPOINT}/appversions?`;

// Geo-Targeted Promotions
export const REACT_APP_API_GEO_CAMPAIGNS = `${envValues.REACT_APP_API_ENDPOINT}/geo-campaigns`;

// CoffeeDrops Campaigns
export const REACT_APP_API_CAMPAIGNS = `${envValues.REACT_APP_API_ENDPOINT}/campaigns`;
export const REACT_APP_API_CAMPAIGN_UPLOAD_BANNER = `${envValues.REACT_APP_API_ENDPOINT}/campaigns/upload-banner`;
export const REACT_APP_API_CAMPAIGN_GIVEAWAY_ENTRIES = (campaignId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/campaigns/${campaignId}/giveaway-entries`;
export const REACT_APP_API_CAMPAIGN_RUN_DRAWING = (campaignId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/campaigns/${campaignId}/run-drawing`;
export const REACT_APP_API_CAMPAIGN_FORFEIT_PROMOTE = (campaignId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/campaigns/${campaignId}/forfeit-promote`;
export const REACT_APP_API_CAMPAIGN_RELEASE_RESERVE = (campaignId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/campaigns/${campaignId}/release-reserve`;
export const REACT_APP_API_CAMPAIGN_ACTIVITY = (campaignId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/campaigns/${campaignId}/activity`;
export const REACT_APP_API_CAMPAIGN_CAFE_INVITATIONS = (campaignId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/campaigns/${campaignId}/cafe-invitations`;
export const REACT_APP_API_CAMPAIGN_CAFE_INVITATION_RESEND = (campaignId, invitationId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/campaigns/${campaignId}/cafe-invitations/${invitationId}/resend`;

// CoffeeDrops Redemptions
export const REACT_APP_API_REDEMPTIONS = `${envValues.REACT_APP_API_ENDPOINT}/redemptions`;
export const REACT_APP_API_REDEMPTIONS_STATS = `${envValues.REACT_APP_API_ENDPOINT}/redemptions/stats`;
export const REACT_APP_API_REDEMPTIONS_GROUPS = `${envValues.REACT_APP_API_ENDPOINT}/redemptions/groups`;
export const REACT_APP_API_REDEMPTIONS_FILTERS = `${envValues.REACT_APP_API_ENDPOINT}/redemptions/filters`;
export const REACT_APP_API_REDEMPTIONS_EXPORT = `${envValues.REACT_APP_API_ENDPOINT}/redemptions/export`;
export const REACT_APP_API_REDEMPTION_VOID = (redemptionId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/redemptions/${redemptionId}/void`;
export const REACT_APP_API_REDEMPTION_REDEEM = (redemptionId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/redemptions/${redemptionId}/redeem`;
export const REACT_APP_API_REDEMPTION_RESTORE = (redemptionId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/redemptions/${redemptionId}/restore`;
export const REACT_APP_API_REDEMPTION_APPROVE = (redemptionId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/redemptions/${redemptionId}/approve`;
export const REACT_APP_API_REDEMPTION_MARK_PAID = (redemptionId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/redemptions/${redemptionId}/mark-paid`;
export const REACT_APP_API_REDEMPTION_REJECT = (redemptionId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/redemptions/${redemptionId}/reject`;
export const REACT_APP_API_REDEMPTION_FLAG = (redemptionId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/redemptions/${redemptionId}/flag`;

// CoffeeDrops Participant Restrictions (API path is singular to match auth module)
export const REACT_APP_API_PARTICIPANT_RESTRICTIONS = `${envValues.REACT_APP_API_ENDPOINT}/participant-restriction`;
export const REACT_APP_API_PARTICIPANT_RESTRICTION_STATS = `${envValues.REACT_APP_API_ENDPOINT}/participant-restriction/stats`;
export const REACT_APP_API_PARTICIPANT_RESTRICTION_USERS = `${envValues.REACT_APP_API_ENDPOINT}/participant-restriction/users`;
export const REACT_APP_API_PARTICIPANT_RESTRICTION_LIFT = (id) =>
  `${envValues.REACT_APP_API_ENDPOINT}/participant-restriction/${id}/lift`;
export const REACT_APP_API_PARTICIPANT_RESTRICTION_ESCALATE = (id) =>
  `${envValues.REACT_APP_API_ENDPOINT}/participant-restriction/${id}/escalate`;

// Drink Identity Tags (API path has no hyphens — must match auth module "drinkidentitytags")
export const REACT_APP_API_DRINK_IDENTITY_TAGS = `${envValues.REACT_APP_API_ENDPOINT}/drinkidentitytags`;
export const REACT_APP_API_DRINK_IDENTITY_TAG_ASSIGNMENTS = `${envValues.REACT_APP_API_ENDPOINT}/drinkidentitytags/assignments`;
export const REACT_APP_API_DRINK_IDENTITY_TAG_MENU_SEARCH = `${envValues.REACT_APP_API_ENDPOINT}/drinkidentitytags/menu-search`;
export const REACT_APP_API_DRINK_IDENTITY_TAG_APPLY_BY_FILTER = `${envValues.REACT_APP_API_ENDPOINT}/drinkidentitytags/assignments/apply-by-filter`;
export const REACT_APP_API_DRINK_IDENTITY_TAG_APPLY_JOB_STATUS = `${envValues.REACT_APP_API_ENDPOINT}/drinkidentitytags/assignments/apply-by-filter`;
export const REACT_APP_API_DRINK_IDENTITY_TAG_ITEM_DETAILS = `${envValues.REACT_APP_API_ENDPOINT}/drinkidentitytags/details/menu-item`;

export const REACT_APP_API_CAMPAIGN_SUPPORT = `${envValues.REACT_APP_API_ENDPOINT}/campaign-support`;
export const REACT_APP_API_DRINK_IDENTITY_TAG_MODIFIER_DETAILS = `${envValues.REACT_APP_API_ENDPOINT}/drinkidentitytags/details/modifier`;
export const REACT_APP_API_DRINK_IDENTITY_TAG_DRINK_TYPE_DEFAULTS = (drinkTypeId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/drinkidentitytags/drink-types/${drinkTypeId}/defaults`;